import React, { useEffect, useState } from "react";
import { Select, Button, Card, Form, notification, Skeleton, Spin } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { useStoreUpdaterWithAPI } from "../../../../Hooks/UseStoreUpdaterWithApi";
import { MeterConfigGrid } from "../../../../Common/UIConstants";
import { useSelector } from "react-redux";
import { CONFIGURATION_METER } from "../../../../Common/Constants";
import MeterPopup from "../../../CommonScreens/CreateMeter";
import { APIConstants } from "../../../../Common/APIConstants";

const { Option } = Select; 

const DeviceConfiguration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loading, makeRequest } = useStoreUpdaterWithAPI();
  const [isloading, setIsLoading] = useState(true)
  const [isAdd, setIsAdd] = useState(false);
  const [rowData, setRowData] = useState([]) 
  const mode = useSelector((state) => state.darkMode);
  const [optionconverter, setOptionConverter] = useState([])
  const { isdarkMode } = mode;
  const [selectedSiteID, setSelectedSiteID] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [form] = Form.useForm();
  const[refetch, setRefetch] =useState(false);
  
  
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 2000)
  })


  useEffect(() => {
    if (location.pathname === `${CONFIGURATION_METER}/device-add-popup`) {
      setIsAdd(true);
    } else {
      setIsAdd(false);
    }
  }, [location.pathname]);


  const handleNotification = (msg,status) => {
    notification.open({
      message: msg,
      type: status,
      placement: 'topRight',
      duration: 3, 
    });
  };

  const handleUpdatePopup = (rowData) => {
    console.log("Selected Row Data:", rowData);  // Log the row data
    setSelectedRow(rowData);  // Set selectedRow
    setIsAdd(false);           // Make sure it's not in add mode
    setIsUpdate(true);         // Set update mode to true
    // Wait for state update to complete before navigating
    navigate(`${CONFIGURATION_METER}/device-add-popup`);
  };
  
  useEffect(() => {
    console.log("Selected Row in Modal:", selectedRow); 
    if (isAdd && !selectedRow) {
      form.resetFields(); 
    } else if (isUpdate && selectedRow) {
      form.setFieldsValue(selectedRow); 
    }
  }, [isAdd, isUpdate, selectedRow, form]);
  

  const setIdSelected =(value) => {
    localStorage.setItem("selectedSiteID", value);
    console.log(value)
    setSelectedSiteID(value);
    setRefetch(!refetch)
  }
  

  const handleAddPopup = () => {
    setSelectedRow(null);     
    setIsAdd(true);            // Set add mode to true
    setIsUpdate(false);        // Make sure you're not in update mode
    navigate(`${CONFIGURATION_METER}/device-add-popup`); 
  };
  

  const getResponse = () => {
    setIsLoading(true);
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_METER}?SiteID=${selectedSiteID}`,
    }).then((res) => {
      setIsLoading(false);
      if (Array.isArray(res)) {
        const updatedData = res.map((item) => ({
          ...item,
          actions: {
            update: handleUpdatePopup,
            confirmDelete: handleDeleteSubmit,
          },
        }));
        setRowData(updatedData);
        onClose();
      } else {
        console.error('Expected array but got:', res);
      }
    }).catch((err) => {
      setIsLoading(false);
      console.error('API request failed', err);
    });
  };

  useEffect(() => {
    if (selectedSiteID) {
      getResponse();
    }
  }, [selectedSiteID,refetch]);


  const handleDeleteSubmit = (meterID, departmentID, siteID) => {
    if (!meterID || !departmentID || !siteID) {
      console.error("Missing required data for deletion");
      return;
    }
    makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_DEVICE_DETAILS}?METERID=${meterID}&DEPARTMENTID=${departmentID}&SITEID=${siteID}`,
    }).then(() => {
      handleNotification("Successfully Deleted",'success');
      const savedValue = localStorage.getItem("selectedSiteID");
      console.log(savedValue)
      setIdSelected(savedValue)
    }).catch((err) => {
      console.error( err);
      handleNotification("Error while deleting",'error');
    });
  };


  const getConverter = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_CONVERTER}`,
    }).then((res) => {
      console.log("Converter:", res);
      if(res&&res.length>0){
        setOptionConverter(res);
      }
    });
  };


  useEffect(() => {
    if (optionconverter.length === 0) {
      getConverter();
    }
  }, [optionconverter]);


  return (
    <div>
      {
        isloading ? (
          <div>
            <Skeleton active />
          </div>
        ) : (
          <Card
            className={`w-full h-auto dark ${!isdarkMode ? "bg-slate-50 border-0" : "bg-slate-900"} `}>
            <div className="flex justify-between">
 
              <div className="overflow-auto">
                <label className={` mr-3 ${isdarkMode ? 'darkfont' : 'whitemode'}`}>Devices Grid View</label>
                <Select 
                  style={{ width: 180, marginBottom: 16 }}
                  onChange={(value) => setIdSelected(value)}
                  value={selectedSiteID}
                  className={` ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} `}
                  dropdownClassName={isdarkMode ? 'select-dropdown-background' : 'light-mode-dropdown'}
                  placeholder="Select a device"
                >
                  {optionconverter.map((item) => (
                    <Option key={item.siteID} value={item.siteID}>
                      {item.siteName}
                    </Option>
                  ))} 
                </Select>
              </div>

              <Button onClick={handleAddPopup} className="blue-btn mb-2">
                Add Devices
              </Button>
            </div>
            {
              rowData.length > 0 &&
            <Spin indicator={<Spin size="large" />} spinning={loading}>
              <MeterConfigGrid
                data={rowData}
                handleDeleteSubmit={handleDeleteSubmit}
              />
            </Spin>
            }

            <MeterPopup
              isAdd={isAdd}
              setIsAdd={setIsAdd}
              isUpdate={isUpdate}
              setIsUpdate={setIsUpdate}
              setRefetch={setRefetch}
              refetch={refetch}
              title={selectedRow ? "Edit Meter" : "Add New Meter"}
              selectedRow={selectedRow}
            />
          </Card>
        )
      }

    </div>
  );
};

export default DeviceConfiguration;
